import React, { useRef, useEffect, useState } from 'react';
import './ResizableSplitter.css';

function ResizableSplitter({ orientation = 'horizontal', onResize, minSize = 0.2 }) {
    const splitterRef = useRef(null);
    const [isDragging, setIsDragging] = useState(false);
    const [startPos, setStartPos] = useState(0);
    const [startSize, setStartSize] = useState(0.5);

    useEffect(() => {
        const handleMouseMove = (e) => {
            if (!isDragging || !splitterRef.current) return;

            const container = splitterRef.current.parentElement;
            if (!container) return;

            const containerRect = container.getBoundingClientRect();
            const isHorizontal = orientation === 'horizontal';
            const mousePos = isHorizontal ? e.clientX : e.clientY;
            const containerSize = isHorizontal ? containerRect.width : containerRect.height;
            const relativePos = mousePos - (isHorizontal ? containerRect.left : containerRect.top);
            
            let newSize = relativePos / containerSize;

            // Apply minimum size constraints
            if (newSize < minSize) newSize = minSize;
            if (newSize > 1 - minSize) newSize = 1 - minSize;

            if (onResize) {
                onResize(newSize);
            }
        };

        const handleMouseUp = () => {
            setIsDragging(false);
        };

        if (isDragging) {
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
            document.body.style.cursor = orientation === 'horizontal' ? 'col-resize' : 'row-resize';
            document.body.style.userSelect = 'none';
        }

        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
            document.body.style.cursor = '';
            document.body.style.userSelect = '';
        };
    }, [isDragging, orientation, onResize, minSize]);

    const handleMouseDown = (e) => {
        e.preventDefault();
        setIsDragging(true);
        const container = splitterRef.current?.parentElement;
        if (container) {
            const containerRect = container.getBoundingClientRect();
            const isHorizontal = orientation === 'horizontal';
            const mousePos = isHorizontal ? e.clientX : e.clientY;
            const containerSize = isHorizontal ? containerRect.width : containerRect.height;
            const relativePos = mousePos - (isHorizontal ? containerRect.left : containerRect.top);
            setStartPos(relativePos);
            setStartSize(relativePos / containerSize);
        }
    };

    return (
        <div
            ref={splitterRef}
            className={`resizable-splitter resizable-splitter-${orientation} ${isDragging ? 'dragging' : ''}`}
            onMouseDown={handleMouseDown}
        >
            <div className="splitter-handle" />
        </div>
    );
}

export default ResizableSplitter;
